import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './alert.scss';

export default ({ isOpen, toggle, alertType, content, callBackAlert }) => {
  let location = useLocation();
  let pathname = location.pathname

  let isModalOpen = isOpen
  if (alertType === 'adminClaimMessageCount' && pathname === '/claim') isModalOpen = false
  if (alertType === 'adminChatMessageCount' && pathname === '/chatBlock') isModalOpen = false
  if (alertType === 'adminBothMessageCount' && pathname === '/claim') content = 'There are new messages in the chat section'
  if (alertType === 'adminBothMessageCount' && pathname === '/chatBlock') content = 'There are new messages in the claim section'

  const redirectLink = () => {
    toggle(!isOpen)
    if (alertType === "postNeed" || alertType === "postInventory" || alertType === "postDelete") {
      callBackAlert()
    }
  }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='alertModal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div className='modal-content'>
              <p>{content}</p>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                toggle(!isOpen)
              }}>
              {alertType === 'postDelete' ? 'No' :
                (['adminClaimMessageCount', 'adminChatMessageCount', 'adminBothMessageCount'].includes(alertType)) ? 'OK' : 'Cancel'}     
            </Button>
            {!alertType.includes('MessageCount') && 
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                redirectLink()
              }}>
                {alertType === 'postDelete' ? 'Yes' : 'Confirm'}              
            </Button>
            }
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
